import React from "react";

const AuthForm = ({ formData }) => {
  return (
    <>
      {formData ? (
        <div className="shadow py-2 pb-5 mt-3">
          {formData?.available ? (
            <iframe
              title="AuthForm"
              width="100%"
              height="700px"
              src={`https://app.pandadoc.com/s/${formData.formId}`}
            ></iframe>
          ) : (
            <iframe
              title="AuthForm"
              width="100%"
              height="700px"
              src="https://eform.pandadoc.com/?eform=ff5234d6-78d3-47ee-b4e2-ed2f374fb997"
            ></iframe>
          )}
        </div>
      ) : null}
    </>
  );
};

export default AuthForm;
